/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_no_with_id = /** @type {(inputs: { id: NonNullable<unknown> }) => string} */ (i) => {
	return `Objednávka č. ${i.id}`
};

const da_order_no_with_id = /** @type {(inputs: { id: NonNullable<unknown> }) => string} */ (i) => {
	return `Ordrenr. ${i.id}`
};

const de_order_no_with_id = /** @type {(inputs: { id: NonNullable<unknown> }) => string} */ (i) => {
	return `Bestell-Nr. ${i.id}`
};

const en_order_no_with_id = /** @type {(inputs: { id: NonNullable<unknown> }) => string} */ (i) => {
	return `Order No. ${i.id}`
};

const es_order_no_with_id = /** @type {(inputs: { id: NonNullable<unknown> }) => string} */ (i) => {
	return `Pedido n°${i.id}`
};

const fr_order_no_with_id = /** @type {(inputs: { id: NonNullable<unknown> }) => string} */ (i) => {
	return `Commande n°${i.id}`
};

const hu_order_no_with_id = /** @type {(inputs: { id: NonNullable<unknown> }) => string} */ (i) => {
	return `Rendelés sz. ${i.id}`
};

const it_order_no_with_id = /** @type {(inputs: { id: NonNullable<unknown> }) => string} */ (i) => {
	return `Ordine n°${i.id}`
};

const nl_order_no_with_id = /** @type {(inputs: { id: NonNullable<unknown> }) => string} */ (i) => {
	return `Bestelnummer ${i.id}`
};

const pl_order_no_with_id = /** @type {(inputs: { id: NonNullable<unknown> }) => string} */ (i) => {
	return `Zamówienie nr ${i.id}`
};

const pt_order_no_with_id = /** @type {(inputs: { id: NonNullable<unknown> }) => string} */ (i) => {
	return `Pedido nº${i.id}`
};

const sv_order_no_with_id = /** @type {(inputs: { id: NonNullable<unknown> }) => string} */ (i) => {
	return `Beställning nr ${i.id}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ id: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const order_no_with_id = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_no_with_id(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_no_with_id", locale)
	if (locale === "cs") return cs_order_no_with_id(inputs)
	if (locale === "da") return da_order_no_with_id(inputs)
	if (locale === "de") return de_order_no_with_id(inputs)
	if (locale === "en") return en_order_no_with_id(inputs)
	if (locale === "es") return es_order_no_with_id(inputs)
	if (locale === "fr") return fr_order_no_with_id(inputs)
	if (locale === "hu") return hu_order_no_with_id(inputs)
	if (locale === "it") return it_order_no_with_id(inputs)
	if (locale === "nl") return nl_order_no_with_id(inputs)
	if (locale === "pl") return pl_order_no_with_id(inputs)
	if (locale === "pt") return pt_order_no_with_id(inputs)
	return sv_order_no_with_id(inputs)
};